import { useUser } from '~/hooks/useUser';
import useSWR from 'swr';
import { get } from '~/lib/providers/supabase/swr';
import { NestedUser } from '@habity/types';

/**
 * Hook to get user data via SWR for real-time updates.
 * 
 * Components using this hook will automatically update when
 * mutate(['users', userId]) is called anywhere in the app.
 */
export const useUserData = () => {
  const { user: appUser } = useUser();

  const { data: userData } = useSWR<NestedUser>(
    appUser?.id ? ['users', appUser.id] : null,
    ([table, userId]) => get(table, Number(userId)),
    {
      revalidateOnFocus: false,
      // No dedupingInterval - always allow immediate revalidation
    }
  );

  return userData;
};
